import axios  from "axios";
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
})

export default {
  namespaced: true,
  state: {
    userFieldSettings: {},
    isLoading: false,
    isUpdateSuccess: false,
    isUpdateError: false,
  },
  getters: {
    getUserFieldSettings: (state) => state.userFieldSettings,
  },
  actions: {
    async fetchUserFieldSettings({ commit }) {
      commit('setIsLoading', true);
      try {
        const response = await apiClient.get('/user-field-settings');
        commit('setUserFieldSettings', response.data);
      } catch (error) {
        console.error("Error fetching user field settings:", error);
      } finally {
        commit('setIsLoading', false);
      }
    },
    async updateUserFieldSettings({ commit }, payload) {
      commit('setIsUpdateSuccess', false);
      commit('setIsLoading', true);
      try {
        await apiClient.put('/user-field-settings', payload);
        commit('setIsUpdateSuccess', true);
      } catch (error) {
        console.error("Error updating user field settings:", error);
        commit('setIsUpdateError', true);
      } finally {
        commit('setIsLoading', false);
      }
    },
  },
  mutations: {
    setUserFieldSettings(state, settings) {
      state.userFieldSettings = settings;
    },
    setIsLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
    setIsUpdateSuccess(state, isSuccess) {
      state.isUpdateSuccess = isSuccess;
    },
    setIsUpdateError(state, isError) {
      state.isUpdateError = isError;
    },
  },
}
